// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"45":"1de3f2cd","181":"426d2f9f","711":"ca1e1da5"}[chunkId] + ".chunk.css";
};